(function (app) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Mcknight",
                {
                    url: "/Mcknight",
                    component: "e4lmcknight",
                    PageTitle: "Elevate for Life - David McKnight"
                });
        }
    ]);

    app.component("e4lmcknight",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Mcknight/Mcknight.html",
            controller: e4LMcknightCtrl,
            bindings: {
            }
        });

    e4LMcknightCtrl.$inject = ["$timeout", "$state", "$mdDialog", "$filter", "ssoApi", "externalLoading"];

    function e4LMcknightCtrl($timeout, $state, $mdDialog, $filter, ssoApi, externalLoading) {
        var $ctrl = this;

        this.ActivatePowerOfZeroSso = function () {
            var w = window.open();
            w.document.write(externalLoading.html);
            ssoApi.initiatePowerOfZeroSso().then(function (data) {
                //console.log(data);
                w.document.write(data);
                w.document.forms.powerofzero.submit();
            }, function () {
                w.document.write(" Failed.  There was an error accessing this resource.");
            });
        }
    }



})(window.app);